// @flow

import type { WebPushNotificationsManagerState } from './types';
import authenticationState from './Authentication/initialState';
import searchNotificationsInitialState from './SearchNotifications/initialState';
import deleteSearchNotificationInitialState from './DeleteSearchNotification/initialState';
import snackbarInitialState from './Snackbar/initialState';
import loaderNotificationsReducer from './LoaderNotifications/reducer';

const notificationsManagerState: WebPushNotificationsManagerState = {
  subscriptionId: authenticationState,
  searchNotifications: searchNotificationsInitialState,
  requestedDeleteSearchNotification: deleteSearchNotificationInitialState,
  snackbar: snackbarInitialState,
  loader: loaderNotificationsReducer,
};

export default notificationsManagerState;



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/initialState.js